<template>
  <b-btn size="sm" variant="secondary" class="ml-2" id="add-additional-price">
    {{ $t('buttons.purchase_invoices.additional_price') }}
    <b-popover target="add-additional-price" placement="bottom" ref="add-additional-price-popover"
               :show.sync="show" @hidden="$emit('handleHidden')">
      <b-row>
        <b-col>
          <label for="additionalPriceData.price_difference">
            {{ `${$t('labels.invoice.additional_price')}, ${base_currency.code}/m3 ` }}
          </label>
          <input id="additionalPriceData.price_difference" class="form-control"
                 v-model="additionalPriceData.price_difference">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label for="additionalPriceData.proc_addit_services">
            {{ $t('labels.invoice.proc_addit_services') }}
          </label>
          <input id="additionalPriceData.proc_addit_services" class="form-control"
                 v-model="additionalPriceData.proc_addit_services">
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-btn variant="success" size="sm" @click="add">
          {{ $t('buttons.common.add') }}
        </b-btn>
      </b-row>
    </b-popover>
  </b-btn>
</template>
<script>
import { mapState } from 'vuex'

/**
 * currently a component for reducing complexity overload in PurchaseInvoice page
 *
 * this is a popover for additional price on fact. evaluation tab.
 * emits: ['handleAdd', 'handleHidden']
 */
export default {
  name: 'WdAdditionalPricePopover',
  data () {
    return {
      show: false,
      additionalPriceData: {
        price_difference: null,
        proc_addit_services: null
      }
    }
  },
  computed: {
    ...mapState('woodware', ['base_currency'])
  },
  methods: {
    add () {
      this.$emit('handleAdd', {
        ...this.additionalPriceData,
        close: () => this.show = false
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/purchase-invoice/WdAdditionalPricePopover.vue